import React, { useContext, PureComponent } from 'react'
import 'styles/getStarted.scss'
import { ModalContext } from 'providers/Modal'

class Sticky extends PureComponent {
  state = {
    position: 'static',
  }
  getDocumentHeight = () => {
    const body = document.body
    const html = document.documentElement
    const height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    )
    return height
  }
  handleScroll = event => {
    if (!this.wrapRef) return
    const initialTopOffset = this.wrapRef.offsetTop
    const currentTopDiff = this.wrapRef.getBoundingClientRect().top
    const scrollTop = Math.max(
      window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop
    )
    this.setState(({ topOffset, position }) => {
      const topOffsetValue = topOffset || initialTopOffset
      return {
        topOffset: topOffsetValue,
        prevDocumentHeight: this.getDocumentHeight(),
        position:
          scrollTop <= topOffset
            ? 'static'
            : currentTopDiff < 1
            ? 'fixed'
            : position,
      }
    })
  }
  handleResize = event => {
    if (!this.wrapRef) return
    this.setState(({ topOffset }) => {
      return {
        topOffset: this.wrapRef.offsetTop,
      }
    })
  }
  componentDidMount = () => {
    this.setState({ prevDocumentHeight: this.getDocumentHeight() })
    document.addEventListener('scroll', this.handleScroll, false)
    window.addEventListener('heightResize', this.handleResize, false)
  }
  componentWillUnmount = () => {
    document.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('heightResize', this.handleResize)
  }
  setWrapRef = element => (this.wrapRef = element)
  get wrapClass() {
    return this.state.position === 'fixed' ? 'stickyFixWrap' : ''
  }
  render = () => (
    <div ref={this.setWrapRef}>
      <div className={this.wrapClass}>{this.props.children}</div>
    </div>
  )
}

function GetStarted(props) {
  const { setActive } = useContext(ModalContext)
  return (
    <Sticky>
      <div className="getStartedWrapper">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 storyHeading">
              Your story is waiting to happen!
            </div>
            <div className="col-md-6 startedWraper">
              <a
                data-testid="get_started"
                href="javascript:void(0)"
                className="getStartedBtn"
                onClick={() => setActive('register')}
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
      </div>
    </Sticky>
  )
}

export default GetStarted
